import { buttonCommon } from "@bevco/Utilities/styleguide/Button";
import { fontFamily } from "@bevco/Utilities/variables";
import { orderUploadStyles as styles } from "@insite/content-library/Components/OrderUpload";
import { css } from "styled-components";

styles.includeFirstRowCheckbox = {
    ...styles.includeFirstRowCheckbox,
    css: css`
        margin: 15px 0;
        display: inline-flex;
        width: 100%;
    `,
};

styles.uploadFileButton = {
    ...styles.uploadFileButton,
    ...buttonCommon,
    variant: "primary",
};

styles.uploadFileButtonLabel = {
    weight: 600,
    fontFamily,
    size: 18,
    lineHeight: "30px",
};

styles.uploadingButtonLabel = {
    weight: 600,
    fontFamily,
    size: 18,
    lineHeight: "30px",
};
